import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import ExcelFile from "react-export-excel-fixed-xlsx/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "react-export-excel-fixed-xlsx/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "react-export-excel-fixed-xlsx/dist/ExcelPlugin/elements/ExcelColumn";
import {convertISODateTimeToBRLocale, convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import {useSelector} from "react-redux";



const useStyles = makeStyles(theme => ({

}));

const ExportarPneusEmCasaXLS = ({
                            dataSet
                     }) => {


    const classes = useStyles();
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    console.log("entrou em DownloadFile");

    const headerSheet = [
        {
            descricao: `de ${periodMin} a ${periodMax}`
        },
        {
            descricao: `acesse a sheet DADOS ao lado, localizada na parte inferior.`
        }
    ];

    return(
        <React.Fragment>
            <ExcelFile filename="PneusEmCasa">
                <ExcelSheet data={headerSheet} name="PneusEmCasa">
                    <ExcelColumn label="Pneus em casa" value="descricao" />
                </ExcelSheet>
                <ExcelSheet data={dataSet} name="Dados">
                    <ExcelColumn label="Ordem Serviço" value="ordemServicoId"/>
                    <ExcelColumn label="Chegada" value={row => convertISODateTimeToBRLocale(row.DTChegada)}/>
                    <ExcelColumn label="Inicio"  value={row => convertISODateTimeToBRLocale(row.DTInicioProducao)}/>
                    <ExcelColumn label="EXF" value={row => convertISODateTimeToBRLocale(row.DTFimProducao)}/>
                    <ExcelColumn label="Cliente" value="cliente"/>
                    <ExcelColumn label="Processo" value="processo"/>
                    <ExcelColumn label="Etapa" value="etapa"/>
                    <ExcelColumn label="DT Etapa" value={row => convertISODateTimeToBRLocale(row.DTUltimaEtapa)}/>
                    <ExcelColumn label="Ciclos validos" value="abreviatura"/>
                    <ExcelColumn label="# Etapas" value="NumEtapas"/>
                    <ExcelColumn label="Etapa" value="etapa"/>
                    <ExcelColumn label="Situacao" value="situacao"/>
                    <ExcelColumn label="Banda Solicitada" value="bandaSolicitada"/>
                    <ExcelColumn label="Banda Aplicada" value="itemBandaAplicada"/>
                    <ExcelColumn label="DOT" value="dot"/>
                    <ExcelColumn label="Marca Fogo" value="marcaFogo"/>
                    <ExcelColumn label="Fabricante" value="fabricante"/>
                    <ExcelColumn label="Modelo" value="modelo"/>
                    <ExcelColumn label="Medida" value="medida"/>



                </ExcelSheet>
            </ExcelFile>
        </React.Fragment>
    );
}

export default ExportarPneusEmCasaXLS;
